/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";
// Overview page components
import Header from "layouts/profile/components/Header";
import { getObjectValue } from "commons/storage";

function Overview() {
  const userData = getObjectValue("user_data");

  const firstName = userData?.customer?.firstName;
  const lastName =
    userData?.customer?.lastName !== undefined &&
    userData?.customer?.lastName !== null
      ? userData?.customer?.lastName
      : "";
  const fullName = firstName + " " + lastName;
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Header>
        <MDBox mt={5}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={12} xl={12} fullwidth>
              <ProfileInfoCard
                className="noneed"
                title="profile information"
                description=""
                info={{
                  fullName: fullName,
                  email: userData?.customer?.email,
                  jobRole: userData?.customer?.jobRole,
                  companyName: userData?.customer?.companyName,
                  companyWebsite: userData?.customer?.companyWebSite,
                }}
                social={[]}
                action={{ route: "", tooltip: "Edit Profile" }}
                shadow={false}
              />
            </Grid>
          </Grid>
        </MDBox>
      </Header>
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
